<!--
 * @Description: 罐车出站
 * @Autor: wangwangwang
 * @Date: 2021-03-30 16:26:14
 * @LastEditors: 刘小二
 * @LastEditTime: 2026-06-03 08:43:21
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main style="display: flex">
        <div>
          <el-collapse-transition>
            <div v-show="showCardNav">
              <div class="search">
                <span style="display: inline-block; margin-bottom: 10px">
                  <span style="margin-right: 12px">车牌号</span>
                  <el-input v-model="tableParam.carNo" style="width: 240px" clearable />
                </span>
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">站点名称</span>
                  <el-select ref="selection" v-model="tableParam.productionSiteId" style="width: 100px" filterable>
                    <el-option v-for="item in stationList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </span>
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">重量干预</span>
                  <el-select ref="selection" v-model="tableParam.weightIntervention" style="width: 100px" clearable>
                    <el-option :key="0" label="否" :value="0"></el-option>
                    <el-option :key="1" label="是" :value="1"></el-option>
                  </el-select>
                </span>
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">过磅时间</span>
                  <el-date-picker v-model="startTimDateEndTimDate" type="datetimerange" unlink-panels
                    value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始时间" end-placeholder="结束时间"
                    @change="(tableParam.startTime = startTimDateEndTimDate ? startTimDateEndTimDate[0] : ''), (tableParam.endTime = startTimDateEndTimDate ? startTimDateEndTimDate[1] : '')"></el-date-picker>
                </span>
                <el-button icon="el-icon-search" size="medium" class="bottom_all"
                  @click="(tableParam.page = 1), gettableData()">查 询</el-button>
                <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
                <el-button icon="el-icon-download" size="medium" class="bottom_all_two" style="margin-left: 12px"
                  @click="load()">导 出</el-button>
              </div>
            </div>
          </el-collapse-transition>
          <div class="hr"></div>
          <div class="card">
            <div class="card_nav">
              <div></div>
              <div>
                <el-dropdown :hide-on-click="false" trigger="click" style="margin: 0 20px">
                  <el-link :underline="false">
                    <span class="el-icon--left">
                      <i class="iconfont iconicon_button_filtrate"></i>
                    </span>
                    筛选
                  </el-link>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="(item, index) in table" :key="index">
                      <el-checkbox v-model="item.status" @change="changeTable">{{ item.label }}</el-checkbox>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
            <div v-loading="tableLoading" class="card_info" :style="style">
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
                style="width: 100%" :data="tableData" tooltip-effect="dark">
                <template v-for="(item, index2) in table">
                  <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center"
                    :width="item.width">
                    <template slot-scope="scope">
                      <span v-if="item.label == '过磅照片'">
                        <el-button size="mini" class="bottom_one" @click="lookPicture(scope.row)">查看</el-button>
                      </span>
                      <span v-else-if="item.label == '操作'">
                        <el-button size="mini" class="bottom_two" style="margin-left: 10px"
                          @click="deleteWeight(scope.row.id)"> 删除 </el-button>
                      </span>
                      <span v-else>{{ scope.row[item.prop] }}</span>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </div>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper" :total="total"
            @size-change="sizeChange" @current-change="gettableData()"></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>
    </el-container>
    <lookPicture :visible.sync="lookPictureDig" :urlList="urlList" />
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import { queryPage, downloadURL, deleteWeight } from "@/api/basicConfig/carInnerOut.js";
import { getUserInfo } from "@/utils/auth.js";
import { getUserAutList } from "@/api/common.js";
export default {
  components: {
    lookPicture: () => import('@/components/File/lookPicture.vue'),
  },
  mixins: [mixin],
  data() {
    return {
      table: [
        { label: "任务编号", prop: "id", status: true, width: "220" },
        { label: "物流号", prop: "logisticsCode", status: true, width: "220" },
        { label: "车牌号", prop: "carNo", status: true, width: "auto" },
        { label: "站点", prop: "productionSite", status: true, width: "auto" },
        { label: "生产线", prop: "proLine", status: true, width: "auto" },
        { label: "工程名称", prop: "engineeringName", status: true, width: "200" },
        { label: "浇筑部位", prop: "structuralParts", status: true, width: "150" },
        { label: "标号", prop: "gradeNo", status: true, width: "auto" },
        { label: "票面量（方）", prop: "faceValue", status: true },
        { label: "容重", prop: "unitWeight", status: true, width: "auto" },
        { label: "出站毛重（吨）", prop: "grossWeight", status: true, width: "auto" },
        { label: "出站皮重（吨）", prop: "tareWeight", status: true, width: "auto" },
        { label: "净重（吨）", prop: "netWeight", status: true, width: "auto" },
        { label: "方量（方）", prop: "actualVolume", status: true, width: "auto" },
        { label: "误差量（方）", prop: "residueNum", status: true, width: "auto" },
        { label: "过磅时间", prop: "weightTime", status: true, width: "150" },
        { label: "过磅照片", prop: "pictureUrl", status: true, width: "150" },
        { label: "地磅数据", prop: "weightActual", status: true, width: "150" },
        { label: "操作", prop: "", status: true, width: "150" },
      ],
      queryPage: queryPage,
      DownloadURL: downloadURL,
      tableData: [],
      pagesType: 0,
      startTimDateEndTimDate: [new Date().Format("yyyy-MM-dd 00:00:00"), new Date().Format("yyyy-MM-dd 23:59:59")],
      lookPictureDig: false,
      urlList: [],
    };
  },
  watch: {
    startTimDateEndTimDate(val) {
      if (val?.length > 0) {
        this.tableParam.startTime = val[0];
        this.tableParam.endTime = val[1];
      } else {
        this.tableParam.startTime = "";
        this.tableParam.endTime = "";
      }
    },
  },
  async created() {
    this.UserInfo = await getUserInfo();
    this.tableParam = { ...this.tableParam, startTime: "", endTime: "", carNo: "", type: "type_outer", productionSite: "", productionSiteId: "",weightIntervention:"", };
    this.tableParam.startTime = this.startTimDateEndTimDate[0] || "";
    this.tableParam.endTime = this.startTimDateEndTimDate[1] || "";
    this.stationList = await getUserAutList(true);
    if (this.UserInfo.pointIds.length > 0) {
      this.tableParam.productionSiteId = this.UserInfo.pointIds[0];
    } else {
      this.tableParam.productionSiteId = this.stationList[0].id;
    }
    this.gettableData();
    this.initTable();
  },
  methods: {
    deleteWeight(id) {
      this.$confirm("此操作将永久删除该信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          deleteWeight({ id: id }).then(res => {
            if (res.code == 1001) {
              this.gettableData();
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
          });
        })
        .catch(() => { });
    },
    lookPicture(e) {
      this.lookPictureDig = true;
      this.urlList = e.pictureUrl ? e.pictureUrl.split(",") : [];
    },
    changeTable() {
      window.localStorage.setItem("tableHeader", JSON.stringify(this.table));
    },
    initTable() {
      if (window.localStorage.getItem("tableHeader", this.table)) {
        this.table = JSON.parse(window.localStorage.getItem("tableHeader", this.table));
      }
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
    /*重置数据,此方法必须存在，并且方发只重置条件*/
    init() {
      this.tableParam.carNo = "";
      this.tableParam.productionSite = "";
      this.tableParam.weightIntervention = "";
      if (this.UserInfo.pointIds.length > 0) {
        this.tableParam.productionSiteId = this.UserInfo.pointIds[0];
      } else {
        this.tableParam.productionSiteId = this.stationList[0].id;
      }
      (this.startTimDateEndTimDate = [new Date().Format("yyyy-MM-dd 00:00:00"), new Date().Format("yyyy-MM-dd 23:59:59")]), this.initData();

    },
  },
};
</script>

<style lang="scss" scoped>
.el-input,
.el-select {
  width: 240px;
}

.table_link {
  margin: 0 10px;
  color: $bg_color;
  cursor: pointer;
}

.table_link:hover {
  opacity: 0.8;
}
</style>
